import { render } from "./category-list-page.vue?vue&type=template&id=1ed1306b&scoped=true"
import script from "./category-list-page.vue?vue&type=script&lang=js"
export * from "./category-list-page.vue?vue&type=script&lang=js"

import "./category-list-page.vue?vue&type=style&index=0&id=1ed1306b&scoped=true&lang=css"

import exportComponent from "/Users/girgisnabil/Documents/projects/home-food-plus-full-stack/source/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ed1306b"]])

export default __exports__